import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
    name: 'getDropDown',
    initialState: {
        getDropDown: null,
    },
    reducers: {
        getDropDown: (state, action) => {
            state.getDropDown = action.payload;
        },
    },
});

export const { getDropDown } = slice.actions;
export default slice.reducer;